<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
			@click="fha">
			返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>会员</span><span style="color:#D7230C;">活动</span></div>
							<div class="sm_pub">精彩会员活动</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">会员活动</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div class="top_bottom_T">
					<div class="dtiail_warp">
						<div class="dtiail_title">{{contents.title}}</div>
						<!-- 上传者信息 -->
						<div style="text-align: center;">
							<span>上传日期：{{getLocalTime(contents.create_time)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上传者：{{`${contents.uid}`.substring(0,1)}}&nbsp; *&nbsp;*
								&nbsp;{{`${contents.username}`.substring(3,4)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;阅读数：{{contents.view}}</span>
						</div>
						<!-- 内容渲染 -->
						<div class="cont_dtiail"
							v-html="contents.content"></div>
					</div>
					<div style="width: 95%;margin: 0 auto;height: 100px;margin-top: 20px;">
						<!-- <Xguanyuedu></Xguanyuedu> -->
						<!-- 打赏分享 -->
						<!-- <tabmore :price="0" nologin_type="xptj" name="新品推荐" :tid="$route.query.id"></tabmore> -->
						<div @click="sca"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 35%;">
							<img class="scname" src="../../../imges/dsdsdsds/shoucang1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								收藏
							</div>
						</div>
						<div  @click="getShareInfo"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/weixin1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								微信
							</div>
						</div>
						<div @click="fxkj"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;">
							<img class="scname" src="../../../imges/dsdsdsds/qqkongjian1.png" style="width: 100%;height: 50px;" alt="">
							<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
								空间
							</div>
						</div>
						<div @click="das"
							style="width: 50px;height: 70px;text-align: center;float: left;margin-left: 20px;border-radius: 50%;">
							<img class="scname" src="../../../imges/dsdsdsds/dashang1.png"
								style="width: 100%;height: 50px;" alt="">
								<div style="width: 100%;height: 20px;line-height: 20px;text-align: center;">
									打赏
								</div>
						</div>
					</div>
					<div style="width: 95%;margin: 0 auto;height: 140px;border-top: 1px dashed #ddd;">

					</div>
				</div>
				<!-- 侧边栏 -->
				<div class="top_bottom_B">
					<rightlist></rightlist>
				</div>
			</div>


		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<dashang ref="child" :dsje="dsje"></dashang>
		<myfooter></myfooter>
		<div class="popContainer" v-show="isShowQR" @click="gbgb">
			<vue-qr style="display: inline-block;
		position: absolute;
		top: 40%;
		left: 40%;" :logoSrc="imageUrl" :text="Text" :size="200"></vue-qr>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				imageUrl: 'https://img1.baidu.com/it/u=3311948344,2093308219&fm=253&fmt=auto&app=138&f=PNG?w=500&h=500',
				Text: '',
				isShowQR: false, //二维码显示
				letData: true,
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				dsje: [{
					tid: this.$route.query.id,
					nologin_type: 'hyhd',
					name: '会员活动打赏',
					price: 0,
				}],
				contents: ''
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			gbgb() {
				this.isShowQR = false
				// $('#qrCodeUrl').html = ''
			},
			fxkj() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					const share = {
						title: this.contents.title,
						desc: "海工人|船海智造360°综合服务平台",
						image_url: [this.contents.picture],
						share_url: "https://www.shipoe360.com/#" + this.$route.path + '?id=' + this.id  
					};
					//跳转地址
					location.replace(
						"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
						encodeURIComponent(share.share_url) +
						"&title=" +
						share.title +
						"&pics=" +
						share.image_url.join("|") +
						"&summary=" +
						share.desc
					);
				} else {
					this.$router.replace('/login')
				}
			},
			getShareInfo() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					if (this.letData) {
						let myhref = window.location.href
						console.log(myhref)
						this.Text = myhref
						this.isShowQR = true
						this.letData = false
					} else {
						this.isShowQR = true
					}
				} else {
					this.$router.replace('/login')
				}
			},
			fha() {
				console.log('返回上一层')
				this.$router.go(-1); //返回上一层
			},
			das() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				if (loginInfo) {
					this.$refs.child.isShowZF = true //修改子组件data
				} else {
					this.$router.replace('/login')
				}
			},
			async sca(){
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res =  await http.post('api/picture/personal_collection',{
					uid:loginInfo.id,
					title:this.contents.title,
					picture:this.contents.picture,
					pc_link:this.$route.path + '?id=' + this.id + '&title=' + this.title,
					url_link:this.$route.path + '?id=' + this.id + '&title=' + this.title,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '收藏成功',
						type: 'success'
					});
				} else{
					this.$notify({
						title: '失败',
						message:res.data.msg,
						type: 'error'
					});
				}
			},
		},
		async mounted() {
			let res = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res.data.data

			let res1 = await http.post('api/picture/vippart_message', {
				id: this.id
			})
			this.contents = res1.data.data[0]
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
			dashang: resolve => require(['@/components/dashang/dashang.vue'], resolve),
			vueQr,
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 100%;
		clear:both;
		overflow:hidden;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 80%;
		float: left;
	}

	.top_bottom_B {
		width: 20%;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}
	/* 遮罩层 */
	.popContainer {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		background: rgba(0, 0, 0, 0.6);
	}
</style>
